<div *ngIf="isActive" class="tstr px-2" [ngStyle]="{ 'background': data.options?.backgroundColor, 'height.px': data.options?.height, 'top.px': data.options?.top }">
    <span [ngStyle]="{ 'color': getColor() }"> {{ data.message?.text }} </span>
</div>
